import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { getAppList, saveAppAuth, getAppAuth } from "@/api/app";
export default {
  name: "Datas",
  data: function data() {
    return {
      isIndeterminate: false,
      checkAll: true,
      appList: [],
      dataAuthorityId: [],
      needConfirm: false,
      checkedApps: []
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  methods: {
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      return;
      // this.authAppEnter()
    },
    all: function all() {
      this.dataAuthorityId = _toConsumableArray(this.authoritys);
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    //   选择
    selectAuthority: function selectAuthority() {
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    },
    handleCheckAllChange: function handleCheckAllChange(value) {
      this.checkAll = value;
      this.checkedApps = [];
    },
    handleCheckedAppsChange: function handleCheckedAppsChange() {
      this.checkAll = false;
    },
    authAppEnter: function authAppEnter() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var appAuth, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              appAuth = [];
              if (_this.checkAll) {
                appAuth = ["-1"];
              } else {
                appAuth = _this.checkedApps;
              }
              console.log(appAuth);
              _context.next = 5;
              return saveAppAuth({
                authorityId: _this.row.authorityId,
                apps: appAuth
              });
            case 5:
              res = _context.sent;
              if (res.code == 0) {
                _this.$message({
                  type: "success",
                  message: "设置成功"
                });
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var appListRs, appAuth;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getAppList();
          case 2:
            appListRs = _context2.sent;
            _this2.appList = appListRs.data.list;
            _context2.next = 6;
            return getAppAuth({
              authorityId: _this2.row.authorityId
            });
          case 6:
            appAuth = _context2.sent;
            if (appAuth.data.indexOf(-1) != -1) {
              console.log("aaaa");
              console.log(appAuth.data.indexOf("-1"));
              _this2.checkAll = true;
            } else {
              console.log("bbb");
              _this2.checkAll = false;
              console.log(appAuth.data);
              _this2.checkedApps = appAuth.data;
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};